<template>
  <div class="stats-page">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>单票货运险投保统计</span>
      </div>

      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="投保人公司">
            <el-input v-model="searchForm.companyName" placeholder="投保人公司名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="保单号">
            <el-input v-model="searchForm.policyNo" placeholder="保单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="被保险人">
            <el-input v-model="searchForm.beneficiary" placeholder="被保险人" clearable></el-input>
          </el-form-item>
          <el-form-item label="价格方案">
            <el-input v-model="searchForm.priceName" placeholder="价格方案" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单ID">
            <el-input v-model="searchForm.orderId" placeholder="订单ID" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="sum-bar">
        <strong>投保总额：<span style="color: #ff7300">{{ sum | money }}</span> 元</strong>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="order_id" label="订单ID" width="100" align="center"></el-table-column>
        <el-table-column prop="company_name" label="投保人" width="240" align="center"></el-table-column>
        <el-table-column prop="beneficiary" label="被保险人" width="240" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="130" align="center"></el-table-column>
        <el-table-column prop="channel_name" label="渠道" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">{{ scope.row.channel_name }}({{ scope.row.alias }})</span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="top_channel_name" label="顶级渠道名称" width="180" align="center"></el-table-column>
        <el-table-column prop="price_name" label="价格方案" width="160" align="center"></el-table-column>
        <el-table-column prop="policy_no" label="保单号" width="180" align="center"></el-table-column>
        <el-table-column prop="amount" label="金额(元)" width="100" align="right" :formatter="amountFormat"></el-table-column>
        <el-table-column prop="balance" label="余额(元)" width="120" align="right" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="type" label="类型" width="80" align="center" :formatter="typeFormat"></el-table-column>
        <el-table-column prop="created_at" label="投保时间" width="160" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="effected_at" label="起保时间" width="160" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="expired_at" label="终保时间" width="160" align="center" :formatter="dateFormat"></el-table-column>
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="rows"
          :current-page="page"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from '@/lib/request'
import { getToken } from '@/lib/local'
import ExportJsonExcel from 'js-export-excel'

export default {
  name: 'SingleTicketInsuranceStats',
  data() {
    return {
      loading: false,
      tableData: [],
      sum: 0,
      total: 0,
      page: 1,
      rows: 15,
      searchForm: {
        companyName: '',
        policyNo: '',
        dateRange: [],
        mobile: '',
        beneficiary: '',
        priceName: '',
        orderId: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    buildParams() {
      const params = { product_alias: 'product-', page: this.page, rows: this.rows }
      if (this.searchForm.companyName) params.company_name = this.searchForm.companyName
      if (this.searchForm.policyNo) params.policy_no = this.searchForm.policyNo
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
        params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
      }
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile
      if (this.searchForm.beneficiary) params.beneficiary = this.searchForm.beneficiary
      if (this.searchForm.priceName) params.price_name = this.searchForm.priceName
      if (this.searchForm.orderId) params.order_id = Number(this.searchForm.orderId)
      return params
    },
    async fetchData() {
      this.loading = true
      try {
        const params = this.buildParams()
        const res = await axios.request({
          url: '/v1/admin/cmn/transaction/insurance',
          method: 'get',
          params,
          headers: { 'AppKey': 'BpLnfgDs' }
        })
        this.tableData = res.rows || []
        this.sum = Number(res.sum || 0) / 100
        this.total = Number(res.total || 0)
      } catch (e) {
        console.error('获取投保统计失败', e)
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.fetchData() },
    handleReset() {
      this.searchForm = { companyName: '', policyNo: '', dateRange: [], mobile: '', beneficiary: '', priceName: '', orderId: '' }
      this.page = 1
      this.rows = 15
      this.fetchData()
    },
    handlePageChange(p) { this.page = p; this.fetchData() },
    handleSizeChange(s) { this.rows = s; this.page = 1; this.fetchData() },
    handleExportExcel() {
      const data = this.tableData.map(r => ({
        '订单ID': r.order_id,
        '产品名称': r.product_name,
        '保险公司': r.insurance_company_name,
        '投保人': r.company_name,
        '被保险人': r.beneficiary,
        '投保时间': this.dateFormat(null, null, r.created_at),
        '保单号': r.policy_no,
        '起保时间': this.dateFormat(null, null, r.effected_at),
        '终保时间': this.dateFormat(null, null, r.expired_at),
        '金额(元)': Number(this.moneyFormat(null, null, r.amount)),
        '顶级渠道名称': r.top_channel_name,
        '渠道': r.channel_name ? `${r.channel_name}(${r.alias})` : r.alias,
        '手机号码': r.mobile,
        '价格方案': r.price_name || '干线保',
        '来源': r.source_desc,
        '余额(元)': Number(this.moneyFormat(null, null, r.balance)),
        '类型': this.typeFormat(null, null, r.type)
      }))
      if (!data.length) {
        this.$message.warning('没有查询到数据')
        return
      }
      const option = {
        fileName: '单票货运险投保统计',
        datas: [{ sheetData: data, sheetName: 'sheet', sheetHeader: ['订单ID','产品名称','保险公司','投保人','被保险人','投保时间','保单号','起保时间','终保时间','金额(元)','顶级渠道名称','渠道','手机号码','价格方案','来源','余额(元)','类型'] }]
      }
      const toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    },
    // Element-UI formatter 签名：(row, column, cellValue)
    dateFormat(row, column, cellValue) {
      const ts = cellValue
      if (!ts && ts !== 0) return ''
      let ms = ts
      if (typeof ts === 'number') {
        ms = ts > 1e12 ? ts : ts * 1000
      } else if (typeof ts === 'string') {
        const num = Number(ts)
        if (!isNaN(num)) ms = num > 1e12 ? num : num * 1000
        else ms = ts
      }
      const d = new Date(ms)
      if (isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      const ss = String(d.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
    },
    moneyFormat(row, column, cellValue) {
      const v = cellValue
      if (v == null) return ''
      return (Number(v) / 100).toFixed(2)
    },
    amountFormat(row, column, cellValue) {
      const v = Number(cellValue)
      const t = row.type
      if (t === 1) return (Number(v) / 100).toFixed(2)
      if (v > 0) return '-' + (Number(v) / 100).toFixed(2)
      return '+' + (Math.abs(Number(v)) / 100).toFixed(2)
    },
    typeFormat(row, column, cellValue) {
      const t = cellValue
      if (t === 1) return '充值'
      if (t === 2) return '投保'
      if (t === 4) return '红包抵扣'
      if (t === 64) return '退款'
      return ''
    }
  },
  filters: { money(v) { return Number(v).toFixed(2) } }
}
</script>

<style scoped>
.search-toolbar { margin-bottom: 10px; }
.sum-bar { margin: 8px 0; }
</style>
